import { render, staticRenderFns } from "./DialogEmailEditAllUserGroup.vue?vue&type=template&id=e70979a6&"
import script from "./DialogEmailEditAllUserGroup.vue?vue&type=script&lang=js&"
export * from "./DialogEmailEditAllUserGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports